import { render, staticRenderFns } from "./layout-nav.vue?vue&type=template&id=24af2c5d&"
import script from "./layout-nav.vue?vue&type=script&lang=ts&"
export * from "./layout-nav.vue?vue&type=script&lang=ts&"
import style0 from "./layout-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports